export default "__VITE_ASSET__Dvtkhxxq__"